import {Component, OnInit} from '@angular/core';
import {environment} from '../../../environments/environment';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';

import {AuthInput, AuthType, LoginGQL, User} from '../../../generated/graphql';
import {BaseComponent} from "../../core/base.component";
import {AuthService} from "../../core/auth/auth.service";

declare var $: any;

@Component({
  selector: 'app-authenticate',
  templateUrl: './authenticate.component.html',
  styleUrls: ['./authenticate.component.scss']
})
export class AuthenticateComponent extends BaseComponent implements OnInit {

  model: any = {};

  constructor(public router: Router,
              public route: ActivatedRoute,
              public translate: TranslateService,
              public LoginGQL: LoginGQL,
              private authService: AuthService) {
    super(router, translate);
  }

  ngOnInit(): void {
    // this.loading.show();

    // if (environment.isLoginMock) {
    //     this.showModal('modalLoginEmail');
    //     return;
    // }

    this.route.queryParams.subscribe(data => {
      if (data['error'] != null) {
        console.log(data['error_description']);
        return;
      }
      if (data['code'] != null) {
        this.model.code = data['code'];
        this.model.redirectUri = window.location.protocol + '//' + window.location.host + window.location.pathname;
        this.onLogin();
        return;
      }
      this.redirectAuth();
    });
  }

  redirectAuth() {
    const clientId = environment.client_id;
    const tenantId = environment.tenant_id;
    const p = window.location.pathname.split('/');
    const virtualPath = p.length >= 3 ? '/' + p[1] : '';
    const redirectUrl = window.location.origin + virtualPath + '/authenticate';
    const authUrl = 'https://login.microsoftonline.com/' + tenantId + '/oauth2/v2.0/authorize?client_id=' + clientId + '&response_type=code&redirect_uri=' + redirectUrl + '&response_mode=query&scope=openid%20offline_access%20https://graph.microsoft.com/mail.read&state=12345';
    window.location.href = authUrl;
  }

  onLogin() {
    const obj: AuthInput = new AuthInput();
    obj.code = this.model.code;
    obj.redirectUri = this.model.redirectUri;
    this.LoginGQL.mutate({data: obj}).subscribe(({data}) => {
      this.saveLocalUser(data?.login! as AuthType);
    }, error => super.onError(error));
  }

  saveLocalUser(data: AuthType) {
    this.setToken(data?.token!);
    this.authService.updateUser(data?.user as User);
    this.authService.getStatusAuthenticated();
    this.router.navigate(['/agenda']).then();
  }
}
